import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          eyebrow="常见问题"
          title="关于快猫内容，最常被问到的几个问题"
          desc="把分区、短视频、权限和深夜档的常见疑问集中回答，读完这一节基本能覆盖大部分浏览场景。"
          align="center"
        />

        <div className="mt-10 md:mt-12 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200/80"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                >
                  <span className="font-heading font-bold text-base md:text-lg text-foreground-950">{f.q}</span>
                  <span
                    className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-lg transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                    <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}